var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-0",attrs:{"fill-height":"","fluid":""}},[_c('video',{attrs:{"id":"video","playsinline":"","webkit-playsinline":"","autoplay":"","loop":"","muted":"","controls":false},domProps:{"muted":true}}),_c('THREEjs')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }